/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiation-type.reducer';

export const RadiationTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiationTypeEntity = useAppSelector(state => state.radiationType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiationTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiationType.detail.title">RadiationType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiationType.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiationTypeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.radiationType.name">Name</Translate>
            </span>
          </dt>
          <dd>{radiationTypeEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.radiationType.description">Description</Translate>
            </span>
          </dt>
          <dd>{radiationTypeEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiationType.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiationTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiationType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiationTypeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.radiationType.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{radiationTypeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiationType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiationTypeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.radiationType.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{radiationTypeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationType.modality">Modality</Translate>
          </dt>
          <dd>{radiationTypeEntity.modality ? radiationTypeEntity.modality.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationType.acquisitionParameters">Acquisition Parameters</Translate>
          </dt>
          <dd>{radiationTypeEntity.acquisitionParameters ? radiationTypeEntity.acquisitionParameters.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationType.energy">Energy</Translate>
          </dt>
          <dd>{radiationTypeEntity.energy ? radiationTypeEntity.energy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationType.beamModality">Beam Modality</Translate>
          </dt>
          <dd>{radiationTypeEntity.beamModality ? radiationTypeEntity.beamModality.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationType.technique">Technique</Translate>
          </dt>
          <dd>{radiationTypeEntity.technique ? radiationTypeEntity.technique.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationType.beamParam">Beam Param</Translate>
          </dt>
          <dd>
            {radiationTypeEntity.beamParams
              ? radiationTypeEntity.beamParams.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {radiationTypeEntity.beamParams && i === radiationTypeEntity.beamParams.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationType.dosimetry">Dosimetry</Translate>
          </dt>
          <dd>
            {radiationTypeEntity.dosimetries
              ? radiationTypeEntity.dosimetries.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {radiationTypeEntity.dosimetries && i === radiationTypeEntity.dosimetries.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/radiation-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiation-type/${radiationTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiationTypeDetail;
